import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import Divider from 'shared/components/divider/divider';

import { useConnectorsContextProvider } from 'features/connectors/context/connectors-provider';
import { ConnectorType } from 'features/connectors/domain/connector';
import useConnectorValidation from 'features/connectors/hooks/connector-validation-hook';
import ConnectorSettingsData from 'features/connectors/views/connector-details/connector-settings/connector-settings-data';
import styles from 'features/connectors/views/connector-details/connector-settings/connector-settings.module.scss';
import ConnectorSettingsOrganisation from './connector-settings-organisation';

const ConnectorSettings = () => {
  const { t } = useTranslation('connectors');

  const { connectorDetailsHook } = useConnectorsContextProvider();
  const { isConnectorTypeValid, currentFormType } = useConnectorValidation();

  const isViewing = connectorDetailsHook.viewingMode === 'viewing';
  const isCreating = connectorDetailsHook.viewingMode === 'creation';

  if (isCreating && !isConnectorTypeValid) {
    return <></>;
  }

  const showConnectorSettings = () => {
    const type = isCreating ? currentFormType : connectorDetailsHook.currentSelectedConnector?.type;
    switch (type) {
      case ConnectorType.Vcare:
        return <ConnectorSettingsData />;
      case ConnectorType.NedapOns:
      case ConnectorType.Unknown:
      default:
        return <></>;
    }
  };

  return (
    <div className={`${styles.container} ${isViewing && styles.viewing}`}>
      <div className={styles.settingsItem} data-testid="connectorOrganisationContainer">
        <Typography variant="h5">{t('details.settings.locationsLabel')}</Typography>
        <div className={styles.settingsItemContent}>
          <ConnectorSettingsOrganisation />
        </div>
      </div>
      <Divider className={styles.divider} />
      <div>{showConnectorSettings()}</div>
    </div>
  );
};

export default ConnectorSettings;
